/** Outer tile size for compact game carousels — matches ClassicGameCard grid (136×102px, `h-25.5`). */
const CAROUSEL_COMPACT_TILE_CLASSNAME = 'w-full h-25.5';

export { CAROUSEL_COMPACT_TILE_CLASSNAME };
